export const NFT_REWARD_SIZES = {
  sm: 120,
  md: 160,
  lg: 200,
} as const

export const NFT_REWARD_RADIUS_PX = 40

export const NFT_REWARD_HALO_SIZE_PX = 588

export const NFT_REWARD_HALO_SPIN_DURATION_S = 8
